import React from "react";
import useHoverTooltip from "./useHoverTooltip";
import "./EllipsisText.css";

/** Tooltip shown while its content is hovered or focused; an interactive one stays open under the pointer and scrolls with the arrow keys. */
export default function HoverTooltip({text, label, interactive = false, children}) {
    const {show, hide, scrollWithKeys, tooltip} = useHoverTooltip(text, {interactive});
    if (!text) {
        return children;
    }
    // A disabled button cannot take focus, so the hint doubles as its accessible name.
    const accessibleName = label ?? (typeof text === "string" ? text : undefined);
    const labelProp = typeof children?.type === "string" ? "aria-label" : "ariaLabel";
    const content = accessibleName && React.isValidElement(children) && children.props[labelProp] === undefined
        ? React.cloneElement(children, {[labelProp]: accessibleName})
        : children;

    return (
        <>
            <span className="hoverTooltipTarget" onMouseEnter={show} onMouseLeave={hide} onFocus={show} onBlur={hide}
                  onKeyDown={interactive ? scrollWithKeys : undefined}>
                {content}
            </span>
            {tooltip}
        </>
    );
}
